import React, { useContext, useEffect, useState } from "react";
import { NavLink, Route, Routes } from "react-router-dom";
import Notfound from "./Notfound";
import Client from "../pages/client/Client";
import { AuthContext } from "../context/Authcontext";
import authsService from "../services/auths.service";
import mylogo from "../assets/images/letscoollogowhite.png";
import profileLogo from "../assets/images/user.png";
import Clientoverview from "../pages/client/Clientoverview";
import Profile from "../pages/client/Profile";
import Clientstatistics from "../pages/client/Clientstatistics";
import Clientaircon from "../pages/client/Clientaircon";
import Airconview from "../pages/Airconview";
import clientService from "../services/client.service";
import Preventivemaintenance from "../pages/Preventivemaintenance";
import Pendingcase from "../pages/Pendingcase";
import Aircon from "../pages/Aircon";
import Reactsignatureconvas from "./Reactsignatureconvas";

const Clientlayout = () => {
  /* const userinfo = authsService.userinfo(); */
  const userinfo = authsService.userinfo();
  const { signOut } = useContext(AuthContext);
  const [clientarr, setClientarr] = useState([]);
  const [selectedclient, setSelectedclient] = useState(
    userinfo.user_id != null ? userinfo.user_id : "dummyclient"
  );

  const togglemenu = () => {
    let sidebar = document.querySelector(".sidebar");
    let sidebarBtn = document.querySelector(".sidebarBtn");
    sidebar.classList.toggle("active");
    if (sidebar.classList.contains("active")) {
      sidebarBtn.classList.replace("fa-bars", "fa-align-left");
    } else sidebarBtn.classList.replace("fa-align-left", "fa-bars");
  }; /* <i className="fa fa-bars" aria-hidden="true"></i> */

  //use effects
  useEffect(() => {
    getallClient();
  }, []);

  const selectclientfn = (value) => {
    localStorage.setItem("selectedclient", value);
    setSelectedclient(value);
    window.location.reload();
  };

  //get allclient
  const getallClient = async () => {
    var data = {
      limit: 40,
      page: 1,
      filter: "",
      search: "",
      between: "",
      sort: "",
      group: "",
    };
    return await clientService
      .getallClient(data)
      .then((res) => {
        if (res.data.result) {
          setClientarr(res.data.result.data);
        } else {
          setClientarr([]);
        }
      })
      .catch((err) => {
        setClientarr([]);
      });
  };
  return (
    <div className="dashboard-layout-container">
      <div style={{ background: "#0503C5" }} className="sidebar ">
      <a  className="btn closetoggl" style={{ position: "absolute",color:"white", right: 0,padding:6, }} onClick={togglemenu}>X</a>

        <div className="logo-details ps-3">
          {/* <i className='bx bxl-c-plus-plus'></i> */}
          {/* <i className="fa fa-ravelry" aria-hidden="true"></i> */}
          <img
            className=""
            style={{ width: 40, height: 40 }}
            src={mylogo}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = { mylogo };
            }}
            alt=""
          />
          <span className="logo_name ps-3">LETSTECH</span>
        </div>
        <div
          style={{
            marginTop: -30,
            paddingLeft: 72,
            whiteSpace: "nowrap",
            fontSize: 10,
          }}
          className=" logo_name text-light"
        >
          <small>Preventive maintenance</small>
          <span className="ms-1 badge border border-white ps-2 pe-2">C</span>
        </div>
        <div className="p-1 mt-3">
          <select
            disabled
            value={selectedclient}
            onChange={(e) => selectclientfn(e.target.value)}
            className="form-select text-white rounded-0"
            aria-label="Default select example"
          >
            <option value="">Select Client</option>
            {clientarr.map((client, index) => (
              <option
                className="text-capitalize"
                key={index}
                value={client.client_id}
              >
                {client.client_fullname}
              </option>
            ))}
          </select>
        </div>
        <ul className="nav-links pt-4">
          <li>
            <NavLink
              to="/"
              className={({ isActive }) =>
                isActive ? "sidebar-nav-active" : "sidebar-nav-links"
              }
            >
              {/*  <i className='bx bx-grid-alt' ></i> */}
              <i className="fa fa-dashboard" aria-hidden="true"></i>
              <span className="links_name">Overview</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/cases"
              className={({ isActive }) =>
                isActive ? "sidebar-nav-active" : "sidebar-nav-links"
              }
            >
              <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
              <span className="links_name">Cases</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/preventivemaintenance"
              className={({ isActive }) =>
                isActive ? "sidebar-nav-active" : "sidebar-nav-links"
              }
            >
              <i className="fa fa-calendar-plus-o" aria-hidden="true"></i>
              <span className="links_name">Adhoc maintenance</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/aircon"
              className={({ isActive }) =>
                isActive ? "sidebar-nav-active" : "sidebar-nav-links"
              }
            >
              <i className="fa fa-table" aria-hidden="true"></i>
              <span className="links_name">My aircons</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/statistics"
              className={({ isActive }) =>
                isActive ? "sidebar-nav-active" : "sidebar-nav-links"
              }
            >
              <i className="fa fa-line-chart" aria-hidden="true"></i>
              <span className="links_name">Statistics</span>
            </NavLink>
          </li>
          
        </ul>
      </div>
      <section style={{ background: "#D7EAFC" }} className="home-section">
        <nav>
          <div onClick={togglemenu} className="sidebar-button">
            {/*  <i className='bx bx-menu sidebarBtn'></i> */}
            <i className="fa fa-bars sidebarBtn" aria-hidden="true"></i>
            <span className="dashboard"></span>
          </div>
          <div className="notify-details">
            {/*  <a href='#'><i className="fa fa-bell" aria-hidden="true"></i></a> */}
            <a href="#" className="notification-container">
              <i className="fa fa-envelope" aria-hidden="true"></i>
              <span className="notification-counter">3</span>
            </a>
            <a href="#" className="notification-container">
              <i className="fa fa-bell" aria-hidden="true"></i>
              <span className="notification-counter">1</span>
            </a>
          </div>
          <div className="profile-details">
            {/* <img src="images/profile.jpg" alt="" /> */}
            <div className="dropdown">
              <a type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <img
                  src={profileLogo}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = { profileLogo };
                  }}
                  alt=""
                />
                <span className="admin_name ">{userinfo.user_name}</span>
              </a>
              <ul className="dropdown-menu mt-1">
                <li>
                  <NavLink to="/profile" className="dropdown-item">
                    {/* <i className='bx bx-log-out'></i> */}
                    Profile
                  </NavLink>
                </li>
                <li className="">
                  <a role="button" onClick={signOut} className="dropdown-item">
                    Logout
                    <span className="ps-3">
                      {" "}
                      <i className="fa fa-sign-out" aria-hidden="true"></i>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <div className="home-content">
          <Routes>
            <Route path="/" element={<Client />} />
            <Route path="/client" element={<Client />} />

            <Route path="/overview" element={<Clientoverview />} />
            <Route path="/statistics" element={<Clientstatistics />} />
            <Route path="/aircon" element={<Aircon />} />
            <Route path="/airconview" element={<Airconview />} />
            <Route path="signature" element={<Reactsignatureconvas />} />

            <Route
              path="/preventivemaintenance"
              element={<Preventivemaintenance />}
            />
            <Route path="/cases" element={<Pendingcase />} />
            <Route path="/profile" element={<Profile />} />

            <Route path="*" element={<Notfound />} />
          </Routes>
        </div>
      </section>
    </div>
  );
};

export default Clientlayout;
